import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const UpDownFilterIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7 15L12 20.5L17 15H7Z" fill="black" fill-opacity="0.87" />
        <path d="M7 9.5L12 4L17 9.5H7Z" fill="black" fill-opacity="0.87" />
      </svg>
    )
  },
)
